import clsx from "clsx";

import { Button } from "common/components/ui/Button";
import { DialogClose, DialogTitle } from "common/components/ui/Dialog";
import { DrawerClose, DrawerTitle } from "common/components/ui/Drawer";
import RadioButton from "common/components/ui/RadioButton";
import { typedObjectEntries } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import { OUTREACH_CRM_EXPORT_OPTIONS } from "../../../../constants";

import type { Dispatch, SetStateAction } from "react";

type Option = keyof typeof OUTREACH_CRM_EXPORT_OPTIONS;

interface ExportOptionsProps {
  selectedOption: Option;
  setSelectedOption: Dispatch<SetStateAction<Option>>;
  onNext: () => void;
}

export default function ExportOptions({
  selectedOption,
  setSelectedOption,
  onNext,
}: ExportOptionsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Close = isDesktop ? DialogClose : DrawerClose;

  return (
    <>
      <Title className="mb-8">Export data to Instantly</Title>
      <div className="flex flex-col gap-y-3">
        {typedObjectEntries(OUTREACH_CRM_EXPORT_OPTIONS).map(
          ([key, { icon: Icon }]) => {
            const isSelected = selectedOption === key;
            const label = `Instantly ${key}`;

            return (
              <button
                key={key}
                type="button"
                onClick={() => setSelectedOption(key)}
                className={clsx(
                  "flex border rounded-4xl p-4 gap-x-3 items-center justify-between transition-colors",
                  isSelected
                    ? "border-purple-500 bg-purple-50"
                    : "border-black-200 bg-white",
                )}
              >
                <div className="flex gap-x-2.5">
                  <span
                    className={clsx(
                      "size-10 flex items-center justify-center transition-colors rounded-2xl",
                      isSelected ? "bg-white" : "bg-black-100",
                    )}
                  >
                    <Icon size={20} weight={isSelected ? "fill" : "regular"} />
                  </span>

                  <div className="flex flex-col gap-y-1">
                    <h2 className="text-md-bold text-left">{label}</h2>
                    <p className="text-black-500 text-xs-medium text-left">
                      Send leads to an existing {label}
                    </p>
                  </div>
                </div>

                <RadioButton checked={isSelected} isStyleOnly />
              </button>
            );
          },
        )}
      </div>
      <div className="flex items-center justify-between gap-x-2.5 mt-8">
        <Close asChild>
          <Button variant="secondary-black">Cancel</Button>
        </Close>

        <Button onClick={onNext}>Next</Button>
      </div>
    </>
  );
}
